import React, { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    addCustomer,
    initAddCustomerAsyncState,
    initUpdateCustomerAsyncState,
    selectAddCustomerAsyncState,
    selectCustomerById,
    selectCustomersCategories,
    selectCustomersGroups,
    selectCustomersNotes2,
    selectCustomersNotes3, selectCustomersNotes4, selectCustomersNotes5, selectCustomersNotes6, selectCustomersNotes7, selectCustomersNotes8,
    selectCustomersNotes9, selectCustomersNotes10, selectCustomersNotes11, selectCustomersNotes12,
    selectCustomersObjs,
    selectPriceMenus,
    selectUpdateCustomerAsyncState,
    updateCustomer
} from 'store/customers/customersSlice';
import {getAgents, selectAgentsNames, selectDrivers, selectGetAgentsAsyncState} from 'store/agents/agentsSlice';
import Customer, { makeCustomer } from 'types/customer';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import 'sweetalert2/src/sweetalert2.scss';
// material-ui
import {
    AppBar,
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Switch,
    TextField, Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import { FormattedMessage } from 'react-intl';
import LoadingButton from '@mui/lab/LoadingButton';
import { ContentCopy, Link as LinkIcon, Send } from '@mui/icons-material';

// third party
import * as yup from 'yup';
import { useFormik } from 'formik';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';
import { SNACKBAR_OPEN } from 'store/actions';
import { Mail, MapPin, Phone } from 'tabler-icons-react';
import JSDB, { ApiCall, NKTypeConvertor } from '../../fromKotlin/nk';
import NoNegative, { NoNegativeInput, WithNegative } from '../../ui-component/textFieldNumber';
import { Link } from 'react-router-dom';
import { IconFilePlus, IconId } from '@tabler/icons';
import { byteArrayToImg, roundDecimals } from '../../fromKotlin/nkutils';
import { Transition } from "./CustomerList";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomerPreview from "./profile/documents/CustomerPreview";
import citiesAndStreets from "../../assets/citiesAndStreets.json";
import { createClientEditLink } from 'api/customer/externalLinks.api';
import { getRepLinkFlags } from 'utils/repLinkFlags';
import { encodeWhatsappShareText } from 'utils/whatsappShareUrl';
import { clientAutocompleteFilter, clientOptionLabel } from '../../utils/sort';

/** Parses text and returns React nodes with URLs rendered as clickable links (marked and open in new tab). */
function linkifyNoteText(text: string): React.ReactNode {
    if (!text) return '—';
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
    const parts = text.split(urlRegex);
    return parts.map((part, i) => {
        const isUrl = /^https?:\/\/.+$/i.test(part) || /^www\..+$/i.test(part);
        if (isUrl) {
            const href = part.startsWith('www.') ? `https://${part}` : part;
            return (
                <a
                    key={i}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}
                >
                    {part}
                </a>
            );
        }
        return part;
    });
}

// types
export interface AddCustomerProps {
    editable?: boolean;
    open: boolean;
    handleDrawerOpen: () => void;
    id: string;
    setPreviewOpen: React.Dispatch<React.SetStateAction<boolean>>;
    updateCallBack?: () => void;
    branches?: {
        name: string,
        id: string,
        branch: number,
        master: number,
    }[];
}

/** City keys in the street file have a trailing space. Trim so "בית חלקיה" finds its streets. */
function normalizeCityStreets(raw: Record<string, string[]>): Record<string, string[]> {
    const merged: Record<string, string[]> = {};
    Object.entries(raw).forEach(([rawCity, rawStreets]) => {
        const city = rawCity.trim();
        if (!city) return;
        const streets = new Set(merged[city] ?? []);
        rawStreets.forEach((rawStreet) => {
            const street = String(rawStreet).trim();
            if (street) streets.add(street);
        });
        merged[city] = Array.from(streets).sort((a, b) => a.localeCompare(b, 'he'));
    });
    return merged;
}

const AddCustomerData = ({ editable = false, open, handleDrawerOpen, id, updateCallBack, branches }: AddCustomerProps) => {
    const dispatch = useDispatch();
    const [cities] = React.useState<Record<string, string[]>>(() => normalizeCityStreets(citiesAndStreets as Record<string, string[]>));
    const addCustomerAsyncState = useSelector(selectAddCustomerAsyncState);
    const updateCustomerAsyncState = useSelector(selectUpdateCustomerAsyncState);
    const customer: Customer = useSelector((state: any) => selectCustomerById(state, id));
    const priceMenus = useSelector(state => selectPriceMenus(state));
    const [sumMenu,setMenu] = React.useState<string[]>(['סיכום רגיל','סיכום תעודות','סיכום מוצרים כללי','סיכום מוצרים מפורט ','לא בשימוש','סיכום תעודות רשתות','סיכום מוצרים רשתות','לא בשימוש','לא בשימוש','לא בשימוש',"סיכום מוצרים עם תעודות","סיכום עם סכום בלבד","מפורט לפי תעודה + נספח תעודות"]);
    // Ordered to match Kotlin's NetworkBillingMode: the index is the stored net_split.
    const [netMenu,setNetMenu] = React.useState<string[]>(["משולב","מפוצל","מפוצל עם ח.פ עצמאי"]);
    const agentsAsyncState = useSelector(selectGetAgentsAsyncState);
    const drivers = useSelector(selectDrivers);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [notePreview, setNotePreview] = React.useState<{ title: string; text: string } | null>(null);
    const createAndLinkRef = React.useRef(false);
    const cardImageInputRef = useRef<HTMLInputElement | null>(null);
    const [linkCreating, setLinkCreating] = React.useState(false);
    const [createdLinkDialog, setCreatedLinkDialog] = React.useState<{
        link: string;
        name: string;
        phone?: string;
    } | null>(null);
    const clientSignEnabled = getRepLinkFlags().clientSignup;
    const [isBranch, setIsBranch] = React.useState(customer?.nkObject?.branch >= 0);
    // A member inherits from the master; only the master decides how the network bills.
    const isNetworkMember = customer?.nkObject?.master !== undefined && customer?.nkObject?.master !== -1;
    const allCustomers = useSelector((state: any) => selectCustomersObjs(state, true));

    /**
     * In מפוצל עם ח.פ עצמאי the card edits the branch's own identity, so an unset ח.פ must
     * read as empty rather than echoing the network's and inviting the user to save it.
     */
    const seedBranchIdentity = (c?: Customer) => {
        if (!c || !isNetworkMember || Number(c.net_split ?? 0) !== 2) return c;
        return { ...c, businessId: c.ownBusinessId ?? '' };
    };

    /**
     * מפוצל עם ח.פ עצמאי is all-or-nothing: name the members that would silently fall back
     * to the network's ח.פ, so the mode is not switched on with half the data missing.
     */
    const warnBranchesMissingOwnBusinessId = () => {
        const masterId = customer?.nkObject?.id;
        if (masterId === undefined) return;
        const missing = (allCustomers ?? [])
            .filter((c: any) => c?.nkObject?.master === masterId && c?.nkObject?.hasValidOwnBusinessIdentity?.() === false)
            .map((c: any) => c?.name ?? c?.nkObject?.getName?.());
        if (missing.length === 0) return;
        Swal.fire({
            title: 'לסניפים הבאים אין ח.פ עצמאי',
            html: `<div style="text-align:right">${missing.map((n: string) => `• ${n}`).join('<br/>')}<br/><br/>עד שיוזן להם ח.פ, החשבוניות שלהם יונפקו על שם הרשת.</div>`,
            icon: 'warning',
            confirmButtonText: 'הבנתי'
        });
    };
    const categories: string[] = useSelector((state: any) => selectCustomersCategories(state));
    const notes2: string[] = useSelector((state: any) => selectCustomersNotes2(state));
    const notes3: string[] = useSelector((state: any) => selectCustomersNotes3(state));
    const notes4: string[] = useSelector((state: any) => selectCustomersNotes4(state));
    const notes5: string[] = useSelector((state: any) => selectCustomersNotes5(state));
    const notes6: string[] = useSelector((state: any) => selectCustomersNotes6(state));
    const notes7: string[] = useSelector((state: any) => selectCustomersNotes7(state));
    const notes8: string[] = useSelector((state: any) => selectCustomersNotes8(state));
    const notes9: string[] = useSelector((state: any) => selectCustomersNotes9(state));
    const notes10: string[] = useSelector((state: any) => selectCustomersNotes10(state));
    const notes11: string[] = useSelector((state: any) => selectCustomersNotes11(state));
    const notes12: string[] = useSelector((state: any) => selectCustomersNotes12(state));
    const groups: string[] = useSelector((state: any) => selectCustomersGroups(state));
    const notes2d = JSDB().getUser().first?.getJsonDesc("cnotes2")
    let labelNotes2 = "הערות לקוח 2";
    if (notes2d) {
        labelNotes2 = notes2d.name;


    }
    const notes3d = JSDB().getUser().first?.getJsonDesc("cnotes3")
    let labelNotes3 = "הערות לקוח 3";
    if (notes3d) {
        labelNotes3 = notes3d.name;

    }

    const notes4d = JSDB().getUser().first?.getJsonDesc("cnotes4")
    let labelNotes4 = "הערות לקוח 4";
    if (notes4d) {
        labelNotes4 = notes4d.name;
    }
    const notes5d = JSDB().getUser().first?.getJsonDesc("cnotes5")
    let labelNotes5 = "הערות לקוח 5";
    if (notes5d) {
        labelNotes5 = notes5d.name;
    }
    const notes6d = JSDB().getUser().first?.getJsonDesc("cnotes6")
    let labelNotes6 = "הערות לקוח 6";
    if (notes6d) {
        labelNotes6 = notes6d.name;
    }
    const notes7d = JSDB().getUser().first?.getJsonDesc("cnotes7")
    let labelNotes7 = "הערות לקוח 7";
    if (notes7d) {
        labelNotes7 = notes7d.name;
    }
    const notes8d = JSDB().getUser().first?.getJsonDesc("cnotes8")
    let labelNotes8 = "הערות לקוח 8";
    if (notes8d) {
        labelNotes8 = notes8d.name;
    }
    const notes9d = JSDB().getUser().first?.getJsonDesc("cnotes9")
    let labelNotes9 = "הערות לקוח 9";
    if (notes9d) {
        labelNotes9 = notes9d.name;
    }
    const notes10d = JSDB().getUser().first?.getJsonDesc("cnotes10")
    let labelNotes10 = "הערות לקוח 10";
    if (notes10d) {
        labelNotes10 = notes10d.name;
    }
    const notes11d = JSDB().getUser().first?.getJsonDesc("cnotes11")
    let labelNotes11 = "הערות לקוח 11";
    if (notes11d) {
        labelNotes11 = notes11d.name;
    }
    const notes12d = JSDB().getUser().first?.getJsonDesc("cnotes12")
    let labelNotes12 = "הערות לקוח 12";
    if (notes12d) {
        labelNotes12 = notes12d.name;
    }
    const agents = useSelector(selectAgentsNames);
    const user = JSDB().getUser().first;
    React.useEffect(() => {
        if(agents.length === 0) {

            dispatch(getAgents());
        }
        dispatch(initAddCustomerAsyncState());
    }, [dispatch]);
    const validationSchema = React.useMemo(() => yup.object({
        name: yup.string().required('שם הלקוח הינו שדה חובה'),
        agent: yup.string().required('שם הסוכן הינו שדה חובה').oneOf(agents, 'סוכן לא קיים'),
        businessName2: yup.string().required('שם חברה הינו שדה חובה'),
        discount: yup.number().min(-100).max(100),
        streetNumber: yup.number().min(0, 'מספר הרחוב אינו תקין'),
        phone: yup.number().min(0, 'מספר טלפון אינו תקין')
    }), [agents]);

    React.useEffect(() => {
        if (addCustomerAsyncState === 'succeeded') {
            if (createAndLinkRef.current) {
                // Create+link flow handles snackbar / drawer itself after minting the link.
                dispatch(initAddCustomerAsyncState());
                return;
            }
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'הלקוח נוסף בהצלחה!',
                variant: 'alert',
                alertSeverity: 'success'
            });
            dispatch(initAddCustomerAsyncState());
            formik.resetForm();
            handleDrawerOpen();
        } else if (addCustomerAsyncState === 'failed') {
            createAndLinkRef.current = false;
            setLinkCreating(false);
            Swal.fire({
                title: 'שגיאה בהוספת לקוח',
                target: '#custom-target',
                text: '',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'המשך'
            });
            dispatch(initAddCustomerAsyncState());
        }
    }, [addCustomerAsyncState, handleDrawerOpen, dispatch]);

    React.useEffect(() => {
        if (updateCustomerAsyncState === 'succeeded') {
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'הלקוח עודכן בהצלחה!',
                variant: 'alert',
                alertSeverity: 'success'
            });
            dispatch(initUpdateCustomerAsyncState());
            if (updateCallBack)
                updateCallBack();
            handleDrawerOpen();
        } else if (updateCustomerAsyncState === 'failed') {
            Swal.fire({
                title: 'שגיאה בעדכון לקוח',
                target: '#custom-target',
                text: '',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#d33',
                confirmButtonText: 'המשך'
            });
            dispatch(initUpdateCustomerAsyncState());
        }
    }, [updateCustomerAsyncState, handleDrawerOpen, dispatch]);

    const formik = useFormik({
        enableReinitialize: true,
        // initialValues: customer || makeCustomer({ withBarcode: user.withBarcode(), withReturns: user.withReturns(), withPrice: user.withPrice(),includeTax:user.includeTax()}),
        initialValues: seedBranchIdentity(customer) || makeCustomer({ withBarcode: user.withBarcode(), withReturns: user.withReturns(), withPrice: user.withPrice(),includeTax:user.includeTax(),notes: user.notesOrTax()}),

        validationSchema,
        onSubmit: (c) => {
            // In משולב/מפוצל the ח.פ field is a locked echo of the network's. Sending it back
            // would overwrite whatever own ח.פ the member still holds.
            const submitted = isNetworkMember && Number(c.net_split ?? 0) !== 2
                ? { ...c, businessId: customer?.ownBusinessId ?? c.businessId }
                : c;
            editable ? dispatch(updateCustomer(submitted)) : dispatch(addCustomer(submitted));
        }
    });

    React.useEffect(() => {
        const clientId = Number(customer?.id);
        if (!editable || !clientId || Number(customer?.cardImage) !== 1) return;
        if (formik.values.image) return;
        let cancelled = false;
        (async () => {
            try {
                const req = new ApiCall('GET_CLIENT_CARD_IMG');
                req.putParam('client_id', clientId);
                await req.execute();
                if (cancelled) return;
                const bytes = JSDB().getClientCardImage(NKTypeConvertor().toKotlinInt(clientId))?.first;
                if (bytes) formik.setFieldValue('image', byteArrayToImg(bytes));
            } catch (e) {
                console.log(e);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [editable, customer?.id, customer?.cardImage]);

    const handleCardImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = function (ev) {
                try {
                    if (ev.target && ev.target.result) {
                        formik.setFieldValue('image', ev.target.result);
                        formik.setFieldValue('cardImage', 1);
                    }
                } catch (err) {
                    console.log(err);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const handleCreateAndSendLink = async () => {
        if (editable || !clientSignEnabled) return;
        const name = String(formik.values.name || '').trim();
        if (!name) {
            formik.setFieldTouched('name', true, true);
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'נא למלא שם לקוח לפני יצירת לינק',
                variant: 'alert',
                alertSeverity: 'error',
            });
            return;
        }
        if (!formik.values.agent) {
            formik.setFieldTouched('agent', true, true);
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'נא לבחור סוכן',
                variant: 'alert',
                alertSeverity: 'error',
            });
            return;
        }
        // Client will fill the rest via the link — seed company name from client name if empty.
        const seeded = {
            ...formik.values,
            name,
            businessName2: String(formik.values.businessName2 || '').trim() || name,
            businessName: String(formik.values.businessName || '').trim() || name,
        };
        const submitted = isNetworkMember && Number(seeded.net_split ?? 0) !== 2
            ? { ...seeded, businessId: customer?.ownBusinessId ?? seeded.businessId }
            : seeded;

        createAndLinkRef.current = true;
        setLinkCreating(true);
        try {
            const result: any = await (dispatch as any)(addCustomer(submitted)).unwrap();
            const created = result?.first;
            const clientId = created?.id ?? created?.getId?.();
            if (!clientId) throw new Error('לא התקבל מזהה לקוח');
            const link = await createClientEditLink(clientId);
            setCreatedLinkDialog({
                link,
                name: created?.name || created?.getName?.() || name,
                phone: created?.phone || created?.getPhone?.() || formik.values.phone,
            });
            formik.resetForm();
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'הלקוח נוצר — שלחו לו את הלינק למילוי פרטים',
                variant: 'alert',
                alertSeverity: 'success',
            });
        } catch (e: any) {
            createAndLinkRef.current = false;
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: e?.message || 'יצירת לקוח / לינק נכשלה',
                variant: 'alert',
                alertSeverity: 'error',
            });
        } finally {
            createAndLinkRef.current = false;
            setLinkCreating(false);
        }
    };

    const weekDays = [
        { value: "sunday", label: "ראשון" },
        { value: "monday", label: "שני" },
        { value: "tuesday", label: "שלישי" },
        { value: "wednesday", label: "רביעי" },
        { value: "thursday", label: "חמישי" },
        { value: "friday", label: "שישי" },
        { value: "saturday", label: "שבת" },
    ]
    return (
        <Box sx={{ p: 3 }}>
            <Tooltip title={<FormattedMessage id='customer-profile' />} onClick={() => {
                setPreviewOpen(true);
            }}>
                <Chip icon={<AccountBoxIcon size='medium' />} sx={{
                    ml: 0.5, mr: 0.5, '& .MuiChip-icon': {
                        color: '#000080',
                    },
                }} label="פרופיל לקוח" variant="outlined" />
            </Tooltip>
            <form onSubmit={formik.handleSubmit}>
                <Grid container alignItems='center' spacing={2}>
                    <Grid item xs={4} sm={4}>
                        <Typography variant='h3'>{editable ? 'עדכן לקוח' : 'הוסף לקוח'}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        {!customer ? <WithNegative

                            placeholder={'אוטומטי'}
                            changer={(v) => {
                                formik.setFieldValue('id', v);

                            }}

                        /> : <Typography variant='h3'>{customer?.id}</Typography>}



                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Tooltip onClick={() => formik.resetForm()} title={<FormattedMessage id='clear' />}>
                            <Chip icon={<DeleteSweepIcon size='medium' />} sx={{
                                ml: 0.5, mr: 0.5, '& .MuiChip-icon': {
                                    color: '#000080',
                                },
                            }} label="נקה" variant="outlined" />

                        </Tooltip>
                    </Grid>
                    <Grid item xs={7} sm={7}>
                        <TextField
                            fullWidth
                            id='name'
                            name='name'
                            label='שם הלקוח'
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />
                    </Grid>
                    <Grid item xs={5} sm={5}>
                        <Grid container justifyContent='flex-start'>
                            <Autocomplete
                                id='agent'
                                inputValue={formik.values.agent}
                                onChange={(event, value) => {
                                    if (value) formik.setFieldValue('agent', value);
                                }}
                                onInputChange={(event, value) => {
                                    if (event) formik.setFieldValue('agent', value);
                                }}
                                onFocus={() => {
                                    if(agents.length === 0) {
                                        dispatch(getAgents());
                                    }
                                }}
                                options={agents ?? []}
                                loading={agentsAsyncState === 'loading'}
                                fullWidth
                                autoHighlight
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='בחר קו'
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {agentsAsyncState === 'loading' ? (
                                                        <CircularProgress color='inherit' size={20} />
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                        error={formik.touched.agent && Boolean(formik.errors.agent)}
                                        helperText={formik.touched.agent && formik.errors.agent}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={7} sm={7}>
                    <div/>
                    </Grid>
                    <Grid item xs={5} sm={5}>
                        <Grid container justifyContent='flex-start'>
                            <Autocomplete
                                id='driver'
                                inputValue={formik.values.driver}
                                onChange={(event, value) => {
                                    if (value) formik.setFieldValue('driver', value);
                                }}
                                onInputChange={(event, value) => {
                                    if (event) formik.setFieldValue('driver', value);
                                }}
                                onFocus={() => {
                                    if(agents.length === 0) {
                                        dispatch(getAgents());
                                    }
                                }}
                                options={drivers.map((a) => a.name) ?? []}
                                loading={agentsAsyncState === 'loading'}
                                fullWidth
                                autoHighlight
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='בחר נהג'
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {agentsAsyncState === 'loading' ? (
                                                        <CircularProgress color='inherit' size={20} />
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                        error={formik.touched.driver && Boolean(formik.errors.driver)}
                                        helperText={formik.touched.driver && formik.errors.driver}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container alignItems='center' spacing={2}>

                            <Grid item xs={6} sm={6}>
                                <FormControl>
                                    <FormControlLabel
                                        value='low'
                                        control={
                                            <Checkbox
                                                checked={formik.values.notes}
                                                onChange={(value) => {
                                                    formik.setFieldValue('notes', value.target.checked );
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='לוקח תעודות משלוח'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <FormControl>
                                    <FormControlLabel
                                        value='low'
                                        control={
                                            <Checkbox
                                                checked={formik.values.visit}
                                                onChange={(value) => {
                                                    formik.setFieldValue('notes', !value.target.checked);
                                                    formik.setFieldValue('visit', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='לוקח תעודות ביקור'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                {(user.no_tax_c == 1) ? <FormControl>
                                    <FormControlLabel
                                        value='medium'
                                        control={
                                            <Checkbox
                                                checked={formik.values.noTaxClient}
                                                onChange={(value) => {
                                                    formik.setFieldValue('noTaxClient', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='לקוח מיוחד ללא מעמ'
                                    />
                                </FormControl> : undefined}

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container alignItems='center' spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='h4'>מצב הדפסה:</Typography>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel
                                        value='low'
                                        control={
                                            <Checkbox
                                                checked={formik.values.withBarcode}
                                                onChange={(value) => {
                                                    formik.setFieldValue('withBarcode', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='ברקוד'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel
                                        value='medium'
                                        control={
                                            <Checkbox
                                                checked={formik.values.withReturns}
                                                onChange={(value) => {
                                                    formik.setFieldValue('withReturns', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='חזרות'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel
                                        value='high'
                                        control={
                                            <Checkbox
                                                checked={formik.values.withPrice}
                                                onChange={(value) => {
                                                    formik.setFieldValue('withPrice', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='מחירים'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel
                                        value='high'
                                        control={
                                            <Checkbox
                                                checked={formik.values.withValue}
                                                onChange={(value) => {
                                                    formik.setFieldValue('withValue', value.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='עם ערך'
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container alignItems='center'>
                            <Grid item xs={3} sm={3}>
                                <Typography variant='h4'>אפשרויות:</Typography>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel
                                        value='high'
                                        control={
                                            <Switch
                                                checked={formik.values.includeTax}
                                                onChange={(value) => {
                                                    formik.setFieldValue('includeTax', value.target.checked);
                                                }}
                                            />
                                        }
                                        label='כולל מעמ'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3} sm={3}>
                                <FormControl>
                                    <FormControlLabel value='high' control={
                                        <Switch
                                            checked={isBranch}
                                            onChange={(value) => {
                                                setIsBranch(value.target.checked);
                                            }}
                                            disabled={id ? true : false}
                                        />}
                                        label='סניף רשת' />
                                </FormControl>
                            </Grid>


                            <Grid item xs={3} sm={3}>
                                <WithNegative
                                    id='discount'
                                    value={formik.values.discount}
                                    changer={(v) =>
                                        formik.setFieldValue('discount', Math.max(-100, Math.min(Number(v), 100)))
                                    }
                                    label='הנחה קבועה (%)'
                                    size='small'
                                    error={formik.touched.discount && Boolean(formik.errors.discount)}
                                    helperText={formik.touched.discount && formik.errors.discount}
                                />
                            </Grid>
                            {isBranch && !id ?
                                <Grid item xs={12} sm={12} mt={2}>
                                    <Autocomplete
                                        id='branch'
                                        inputValue={formik.values.businessName}
                                        onChange={(event, value) => {
                                            const branch = branches?.find((b) => b.name == value);
                                            if (value) {
                                                formik.setFieldValue('master', branch?.master);
                                                formik.setFieldValue('branch', branch?.branch);
                                                formik.setFieldValue('businessName', value);
                                                formik.setFieldValue('businessId', branch?.id)
                                            }
                                        }}
                                        onInputChange={(event, value) => {
                                            const branch = branches?.find((b) => b.name == value);
                                            if (event) {
                                                formik.setFieldValue('master', branch?.master);
                                                formik.setFieldValue('branch', branch?.branch);
                                                formik.setFieldValue('businessName', value);
                                                formik.setFieldValue('businessId', branch?.id)
                                            }
                                        }}
                                        options={branches?.map((b) => b.name) ?? []}
                                        fullWidth
                                        autoHighlight
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='סניף'
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    )
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                : undefined
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Autocomplete
                            id='category'
                            inputValue={formik.values.category}
                            onChange={(event, value) => {
                                if (value) formik.setFieldValue('category', value);
                            }}
                            onInputChange={(event, value) => {
                                if (event) formik.setFieldValue('category', value);
                            }}
                            options={categories ?? []}
                            fullWidth
                            autoHighlight
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label='קטגורית לקוחות'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                        <Autocomplete
                            id='group'
                            inputValue={formik.values.group}
                            onChange={(event, value) => {
                                if (value) formik.setFieldValue('group', value);
                            }}
                            onInputChange={(event, value) => {
                                if (event) formik.setFieldValue('group', value);
                            }}
                            options={groups ?? []}
                            fullWidth
                            autoHighlight
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label='קבוצת לקוחות'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container alignItems='center' spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='h4'>פרטי קשר</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <TextField
                                    fullWidth
                                    id='businessName2'
                                    name='businessName2'
                                    label='שם החברה'
                                    value={formik.values.businessName2}
                                    onChange={formik.handleChange}
                                    error={formik.touched.businessName2 && Boolean(formik.errors.businessName2)}
                                    helperText={formik.touched.businessName2 && formik.errors.businessName2}

                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <TextField
                                    fullWidth
                                    id='businessId'
                                    name='businessId'
                                    label='ח.פ. \ ע.מ.'
                                    type='string'
                                    value={formik.values.businessId}
                                    onChange={formik.handleChange}
                                    // In מפוצל עם ח.פ עצמאי the branch bills under its own ח.פ,
                                    // so this is the one network mode where a member may edit it.
                                    disabled={isBranch && isNetworkMember && Number(formik.values.net_split ?? 0) !== 2}
                                    helperText={
                                        isBranch && isNetworkMember && Number(formik.values.net_split ?? 0) !== 2
                                            ? 'נלקח מהרשת'
                                            : undefined
                                    }
                                />
                            </Grid>

                            <Grid item xs={4} sm={4}>
                                {/* <TextField
                                    fullWidth
                                    id='city'
                                    name='city'
                                    label='עיר'
                                    value={formik.values.city}
                                    onChange={formik.handleChange}
                                /> */}
                                <Autocomplete
                                    id='city'
                                    inputValue={formik.values.city}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('city', value.trim());
                                        document?.getElementById('street')?.focus();
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('city', value.trim());

                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            document?.getElementById('street')?.focus();
                                        }
                                    }}
                                    options={Object.keys(cities)}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='עיר'
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <Autocomplete
                                    id='street'
                                    inputValue={formik.values.street}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('street', value.trim());
                                        document?.getElementById('streetNumber')?.focus();
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('street', value.trim());

                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            document?.getElementById('streetNumber')?.focus();
                                        }
                                    }}
                                    options={cities[String(formik.values.city ?? '').trim()] ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='רחוב'
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id='streetNumber'
                                    name='streetNumber'
                                    label='מספר'
                                    type='number'
                                    value={formik.values.streetNumber}
                                    onChange={formik.handleChange}
                                    error={formik.touched.streetNumber && Boolean(formik.errors.streetNumber)}
                                    helperText={formik.touched.streetNumber && formik.errors.streetNumber}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    id='location'
                                    name='location'
                                    label='מיקום מדוייק GPS'
                                    type='text'

                                    value={formik.values.location}
                                    onChange={formik.handleChange}
                                    error={formik.touched.location && Boolean(formik.errors.location)}
                                    helperText={'מיקום LAT    ,    LON'}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <MapPin size={14} strokeWidth={1} color="#000000" />
                                            </InputAdornment>
                                        )
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id='email'
                                    name='email'
                                    label='אימייל'
                                    type='string'
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Mail
                                                    size={18}
                                                    strokeWidth={2}
                                                    color='#000000'
                                                />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id='contactName'
                                    name='contactName'
                                    label='איש קשר'
                                    value={formik.values.contactName}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={8} sm={8}>
                                <TextField
                                    fullWidth
                                    id='phone'
                                    name='phone'
                                    label='טלפון'
                                    type='tel'
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                                    helperText={formik.touched.phone && formik.errors.phone}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Phone
                                                    size={18}
                                                    strokeWidth={2}
                                                    color='#000000'
                                                />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id='contactName2'
                                    name='contactName2'
                                    label='איש קשר 2'
                                    value={formik.values.contactName2}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={8} sm={8}>
                                <TextField
                                    fullWidth
                                    id='phone2'
                                    name='phone2'
                                    label='טלפון 2'
                                    type='tel'
                                    value={formik.values.phone2}
                                    onChange={formik.handleChange}
                                    error={formik.touched.phone2 && Boolean(formik.errors.phone2)}
                                    helperText={formik.touched.phone2 && formik.errors.phone2}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Phone
                                                    size={18}
                                                    strokeWidth={2}
                                                    color='#000000'
                                                />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id='contactName3'
                                    name='contactName3'
                                    label='איש קשר 3'
                                    value={formik.values.contactName3}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={8} sm={8}>
                                <TextField
                                    fullWidth
                                    id='phone3'
                                    name='phone3'
                                    label='טלפון 3'
                                    type='tel'
                                    value={formik.values.phone3}
                                    onChange={formik.handleChange}
                                    error={formik.touched.phone3 && Boolean(formik.errors.phone3)}
                                    helperText={formik.touched.phone3 && formik.errors.phone3}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Phone
                                                    size={18}
                                                    strokeWidth={2}
                                                    color='#000000'
                                                />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <Grid item>
                                    <TextField
                                        fullWidth
                                        dir='ltr'
                                        inputProps={{ style: { textAlign: 'right' } }}
                                        id='externalId'
                                        name='externalId'
                                        label='מזהה חיצוני'
                                        value={formik.values.externalId}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item>
                                    <NoNegative
                                        fullWidth
                                        id='obligo'
                                        name='obligo'
                                        label='אובליגו'
                                        value={formik.values.obligo}
                                        changer={(v) => {
                                            formik.setFieldValue('obligo', roundDecimals(Math.max(0, Number(v)), 4));
                                        }}
                                        sx={{ mt: 2 }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={8} sm={8}>
                                <Grid item>
                                    <TextField
                                        fullWidth
                                        dir='rtl'
                                        inputProps={{ style: { textAlign: 'right' } }}
                                        id='paymentComments'
                                        name='paymentComments'
                                        label='תנאי תשלום'
                                        value={formik.values.paymentComments}
                                        onChange={formik.handleChange}

                                    />

                                </Grid>
                                <Grid item>
                                    <NoNegative
                                        id='days_to_pay'
                                        value={formik.values.days_to_pay}
                                        changer={(v) =>
                                            formik.setFieldValue('days_to_pay', Math.max(0,Number(v)))
                                        }
                                        label='ימים לתשלום'
                                        size='small'
                                        sx={{ mt: 2 }}
                                    />

                                </Grid>

                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <TextField
                                    fullWidth
                                    id='nameEnglish'
                                    name='nameEnglish'
                                    label='שם באנגלית'
                                    value={formik.values.nameEnglish}
                                    onChange={formik.handleChange}

                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <TextField
                                    fullWidth
                                    id='addressEnglish'
                                    name='addressEnglish'
                                    label='כתובת באנגלית'
                                    value={formik.values.addressEnglish}
                                    onChange={formik.handleChange}

                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Grid item xs={3} sm={3}>
                                    <Typography variant='h4'>ימי חלוקה:</Typography>
                                </Grid>
                                <Grid item xs={9} sm={9}>
                                    <FormControl>
                                        <FormControlLabel value='high' control={
                                            <Switch
                                                checked={formik.values.freeDay}
                                                onChange={(value) => {
                                                    if(value.target.checked){
                                                        formik.setFieldValue('freeDay', true);
                                                    } else {
                                                        formik.setFieldValue('freeDay', false);

                                                    }

                                                }}

                                            />}
                                                          label='לקוח מזדמן' />
                                    </FormControl>
                                </Grid>
                                {
                                    weekDays.map((day, index) => {
                                        return (
                                            <FormControlLabel
                                                key={index}
                                                value='high'
                                                control={
                                                    <Checkbox
                                                        checked={formik.values[day.value]}
                                                        onChange={(value) => {
                                                            formik.setFieldValue(day.value, value.target.checked);
                                                        }}
                                                        color='primary'
                                                        sx={{ color: 'primary.main' }}
                                                    />
                                                }
                                                label={day.label}
                                            />
                                        )
                                    })
                                }
                            </Grid>
                            {true|| user.note_price == 1 ? (
                                <>
                                    <Grid item xs={8} sm={8}>
                                        <Autocomplete
                                            id='priceControl'
                                            value={priceMenus.find((s) => s.id == Number(formik.values.priceControl))}
                                            onChange={(event, value) => {
                                                if (value) formik.setFieldValue('priceControl', value.id);
                                            }}

                                            options={priceMenus ?? []}
                                            getOptionLabel={(option) => clientOptionLabel(option)}
                                            filterOptions={(options, { inputValue }) =>
                                                clientAutocompleteFilter(options, inputValue)
                                            }
                                            fullWidth
                                            autoHighlight
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='מחירון קבוע'
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        )
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                        <Button
                                            variant='contained'
                                            color='error'
                                            onClick={() => {
                                                formik.setFieldValue('priceControl', '');
                                            }}
                                        >
                                            נקה מחירון
                                        </Button>
                                    </Grid>
                                    <Grid item xs={8} sm={8}>
                                        <Autocomplete
                                            id='availableControl'
                                            value={priceMenus.find((s) => s.id == Number(formik.values.availableControl))}
                                            onChange={(event, value) => {
                                                if (value) formik.setFieldValue('availableControl', value.id);
                                            }}
                                            options={priceMenus ?? []}
                                            getOptionLabel={(option) => clientOptionLabel(option)}
                                            filterOptions={(options, { inputValue }) =>
                                                clientAutocompleteFilter(options, inputValue)
                                            }
                                            fullWidth
                                            autoHighlight
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label='זמינות קבועה'
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        )
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={4}>
                                        <Button
                                            variant='contained'
                                            color='error'
                                            onClick={() => {
                                                formik.setFieldValue('availableControl', '');
                                            }}
                                        >
                                            נקה זמינות
                                        </Button>
                                    </Grid>
                                </>
                            )
                                : undefined}

                            <Grid item xs={12} sm={12}>
                                <Autocomplete
                                    id='tax_note_type'
                                    value={sumMenu.find((s,index) => index-1 == Number(formik.values.tax_note_type))}
                                    onChange={(event, value) => {
                                        if (value){
                                            const index = sumMenu.findIndex((s) => s == value);
                                            formik.setFieldValue('tax_note_type', index-1);
                                        }

                                    }}

                                    options={sumMenu ?? []}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='סוג סיכום בחשבונית'
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            {isBranch ?  <Grid item xs={12} sm={12}>
                                {isNetworkMember ? (
                                    // Editing this on a member would look like it changed the
                                    // network and would not, so show it as the fact it is.
                                    <TextField
                                        fullWidth
                                        disabled
                                        label='אופן חיוב הרשת'
                                        value={`${netMenu[Number(formik.values.net_split ?? 0)] ?? netMenu[0]} (נקבע ברשת)`}
                                    />
                                ) : (
                                <Autocomplete
                                    id='net_split'
                                    value={netMenu.find((s,index) => index == Number(formik.values.net_split))}
                                    onChange={(event, value) => {
                                        if (value){
                                            const index = netMenu.findIndex((s) => s == value);
                                            formik.setFieldValue('net_split', index);
                                            if (index === 2)
                                                warnBranchesMissingOwnBusinessId();
                                        }

                                    }}

                                    options={netMenu ?? []}
                                    fullWidth
                                    autoHighlight
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='פיצול חשבונית לרשתות'
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                                )}
                            </Grid>: undefined}

                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    dir='rtl'
                                    inputProps={{ style: { textAlign: 'right' } }}
                                    id='comments'
                                    name='comments'
                                    label='הערות'
                                    value={formik.values.comments}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    dir='rtl'
                                    multiline
                                    minRows={2}
                                    inputProps={{ style: { textAlign: 'right' } }}
                                    id='arrivalInstructions'
                                    name='arrivalInstructions'
                                    label='הוראות הגעה'
                                    value={formik.values.arrivalInstructions ?? ''}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                            }}>
                                <input type='file' accept='image/*' onChange={handleCardImageChange} style={{ display: 'none' }} ref={cardImageInputRef} />
                                {formik.values.image ?
                                    <img id="image-for-client-card" src={formik.values.image} alt="תמונה בכרטיס" style={{
                                        width: '100%',
                                        maxWidth: 440,
                                        maxHeight: 440,
                                    }} />
                                    : null
                                }
                                <Button
                                    variant='contained'
                                    endIcon={<IconFilePlus />}
                                    color="secondary"
                                    onClick={() => cardImageInputRef.current?.click()}
                                    style={{ marginTop: 10 }}
                                >
                                    תמונה בכרטיס
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <NoNegative
                                    fullWidth
                                    id='min_order'
                                    name='min_order'
                                    label='מינימום הזמנה'
                                    value={formik.values.min_order}
                                    changer={(v) => {
                                        formik.setFieldValue('min_order', roundDecimals(Math.max(0, Number(v)), 4));
                                    }

                                    }
                                />
                            </Grid>
                                <Grid item xs={6} sm={6}>
                                <WithNegative
                                    fullWidth
                                    id='min_order_sum'
                                    name='min_order_sum'
                                    label='מינימום בכסף'
                                    value={formik.values.min_order_sum}
                                    changer={(v) => {
                                        formik.setFieldValue('min_order_sum', roundDecimals(Math.max(0, Number(v)), 4));
                                    }

                                    }
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <WithNegative
                                    fullWidth
                                    id='return_pct'
                                    name='return_pct'
                                    label='אחוז החזרות מותר'
                                    helperText='‎-1 חסימת החזרות, 0 ללא מכסה, מספר חיובי = מכסה חודשית באחוזים'
                                    value={formik.values.return_pct}
                                    changer={(v) => {
                                        formik.setFieldValue('return_pct', roundDecimals(Number(v), 4));
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!formik.values.cofcLock}
                                                onChange={(e) => {
                                                    formik.setFieldValue('cofcLock', e.target.checked);
                                                }}
                                                color='primary'
                                                sx={{ color: 'primary.main' }}
                                            />
                                        }
                                        label='נעול בהזמנות מקוון'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes2'
                                    inputValue={formik.values.notes2}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes2', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes2', value);
                                    }}
                                    options={notes2 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes2}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes2, text: formik.values.notes2 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes3'
                                    inputValue={formik.values.notes3}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes3', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes3', value);
                                    }}
                                    options={notes3 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes3}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes3, text: formik.values.notes3 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes4'
                                    inputValue={formik.values.notes4}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes4', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes4', value);
                                    }}
                                    options={notes4 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes4}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes4, text: formik.values.notes4 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes5'
                                    inputValue={formik.values.notes5}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes5', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes5', value);
                                    }}
                                    options={notes5 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes5}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes5, text: formik.values.notes5 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes6'
                                    inputValue={formik.values.notes6}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes6', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes6', value);
                                    }}
                                    options={notes6 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes6}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes6, text: formik.values.notes6 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes7'
                                    inputValue={formik.values.notes7}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes7', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes7', value);
                                    }}
                                    options={notes7 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes7}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes7, text: formik.values.notes7 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes8'
                                    inputValue={formik.values.notes8}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes8', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes8', value);
                                    }}
                                    options={notes8 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes8}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes8, text: formik.values.notes8 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes9'
                                    inputValue={formik.values.notes9}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes9', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes9', value);
                                    }}
                                    options={notes9 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes9}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes9, text: formik.values.notes9 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes10'
                                    inputValue={formik.values.notes10}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes10', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes10', value);
                                    }}
                                    options={notes10 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes10}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes10, text: formik.values.notes10 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes11'
                                    inputValue={formik.values.notes11}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes11', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes11', value);
                                    }}
                                    options={notes11 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes11}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes11, text: formik.values.notes11 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Autocomplete
                                    id='notes12'
                                    inputValue={formik.values.notes12}
                                    onChange={(event, value) => {
                                        if (value) formik.setFieldValue('notes12', value);
                                    }}
                                    onInputChange={(event, value) => {
                                        if (event) formik.setFieldValue('notes12', value);
                                    }}
                                    options={notes12 ?? []}
                                    fullWidth
                                    autoHighlight
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={labelNotes12}
                                            inputProps={{ ...params.inputProps, style: { textAlign: 'right' }, dir: 'rtl' }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {params.InputProps.endAdornment}
                                                        <InputAdornment position="end">
                                                            <Tooltip title="הצג בהגדלה">
                                                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setNotePreview({ title: labelNotes12, text: formik.values.notes12 || '' }); }} edge="end" aria-label="view">
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </InputAdornment>
                                                    </>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4} sm={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formik.values.link}
                                            onChange={(e) => formik.setFieldValue('link', e.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label="סימון לשליחה"
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id="from_hour"
                                    name="from_hour"
                                    label="שעת התחלה"
                                    type="time"
                                    value={formik.values.from_hour}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <TextField
                                    fullWidth
                                    id="to_hour"
                                    name="to_hour"
                                    label="שעת סיום"
                                    type="time"
                                    value={formik.values.to_hour}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{
                        position: 'sticky',
                        bottom: 10,
                    }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {!editable && clientSignEnabled ? (
                                <AnimateButton>
                                    <LoadingButton
                                        loading={linkCreating}
                                        fullWidth
                                        variant='outlined'
                                        color='secondary'
                                        disabled={addCustomerAsyncState === 'loading' || updateCustomerAsyncState === 'loading'}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleCreateAndSendLink();
                                        }}
                                        startIcon={<LinkIcon />}
                                    >
                                        צור ושלח לינק ללקוח
                                    </LoadingButton>
                                </AnimateButton>
                            ) : null}
                            <AnimateButton>
                                <LoadingButton
                                    loading={
                                        !linkCreating &&
                                        (addCustomerAsyncState === 'loading' || updateCustomerAsyncState === 'loading')
                                    }
                                    fullWidth
                                    variant='contained'
                                    type='submit'
                                    disabled={linkCreating}
                                >
                                    {editable ? 'שמור' : 'צור לקוח'}
                                </LoadingButton>
                            </AnimateButton>
                        </Box>
                    </Grid>
                </Grid>
            </form>
            {createdLinkDialog ? (
                <Dialog
                    open
                    onClose={() => {
                        setCreatedLinkDialog(null);
                        handleDrawerOpen();
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LinkIcon fontSize="small" />
                        לינק למילוי פרטים ומסמכים
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            הלקוח נוצר. שלחו לו את הלינק (תוקף שעה, חד-פעמי) כדי שימלא פרטים ויעלה מסמכים.
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={2}
                            label="הקישור שנוצר"
                            value={createdLinkDialog.link}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="העתק">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    navigator.clipboard.writeText(createdLinkDialog.link);
                                                    dispatch({
                                                        type: SNACKBAR_OPEN,
                                                        open: true,
                                                        message: 'הקישור הועתק',
                                                        variant: 'alert',
                                                        alertSeverity: 'success',
                                                    });
                                                }}
                                            >
                                                <ContentCopy fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            size="small"
                            inputProps={{ dir: 'ltr' }}
                        />
                    </DialogContent>
                    <DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setCreatedLinkDialog(null);
                                handleDrawerOpen();
                            }}
                        >
                            סגור
                        </Button>
                        <Button
                            variant="outlined"
                            startIcon={<ContentCopy />}
                            onClick={() => {
                                navigator.clipboard.writeText(createdLinkDialog.link);
                                dispatch({
                                    type: SNACKBAR_OPEN,
                                    open: true,
                                    message: 'הקישור הועתק',
                                    variant: 'alert',
                                    alertSeverity: 'success',
                                });
                            }}
                        >
                            העתק קישור
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<Send />}
                            onClick={() => {
                                const text = `שלום ${createdLinkDialog.name},\nנא למלא את הפרטים ולחתום על המסמכים בקישור:\n${createdLinkDialog.link}`;
                                window
                                    ?.open(
                                        `https://api.whatsapp.com/send?text=${encodeWhatsappShareText(text)}&phone=${JSDB().getValidPhone(createdLinkDialog.phone)}`,
                                        '_blank',
                                    )
                                    ?.focus();
                            }}
                            sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#1da851' } }}
                        >
                            שלח בווטסאפ
                        </Button>
                    </DialogActions>
                </Dialog>
            ) : null}
            {previewOpen && customer ? <Dialog TransitionComponent={Transition} fullScreen fullWidth open={previewOpen}
                onBackdropClick={() => {
                    setPreviewOpen(false)

                }}
                sx={{ '& .MuiDialog-paper': { p: 0 } }}>
                <AppBar sx={{ position: 'sticky' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                setPreviewOpen(false)

                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1, color: 'white' }} variant="h6" component="div">
                            סגור חלון
                        </Typography>
                        <Typography onClick={() => {
                            setPreviewOpen(false)

                        }}>
                            {customer?.name}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <CustomerPreview id={customer?.id} />
            </Dialog> : undefined}
            {notePreview != null ? (
                <Dialog
                    open={true}
                    onClose={() => setNotePreview(null)}
                    maxWidth="md"
                    fullWidth
                    TransitionComponent={Transition}
                    PaperProps={{ sx: { direction: 'rtl', textAlign: 'right' } }}
                >
                    <AppBar position="static" sx={{ flexDirection: 'row-reverse' }}>
                        <Toolbar>
                            <Typography sx={{ flex: 1, textAlign: 'center', color: 'white' }} variant="h6">
                                {notePreview.title}
                            </Typography>
                            <IconButton edge="start" color="inherit" onClick={() => setNotePreview(null)} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ p: 2, textAlign: 'right', direction: 'rtl' }}>
                        <Typography component="div" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '1.1rem' }}>
                            {linkifyNoteText(notePreview.text || '')}
                        </Typography>
                    </Box>
                </Dialog>
            ) : null}
        </Box>
    );
};
export default memo(AddCustomerData);
